var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0C4.47297 0 0 4.47254 0 10C0 15.5271 4.47254 20 10 20C15.527 20 20 15.5275 20 10C20 4.47293 15.5275 0 10 0ZM10 18.4375C5.33656 18.4375 1.5625 14.6638 1.5625 10C1.5625 5.33652 5.33621 1.5625 10 1.5625C14.6634 1.5625 18.4375 5.33621 18.4375 10C18.4375 14.6635 14.6638 18.4375 10 18.4375Z",
    fill: "#EE162D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.23254 5.46642C9.23254 5.04851 9.59075 4.75 10.0087 4.75C10.4266 4.75 10.7251 5.04851 10.7251 5.46642V11.0784C10.7251 11.4963 10.4266 11.8545 10.0087 11.8545C9.59075 11.8545 9.23254 11.4963 9.23254 11.0784V5.46642Z",
    fill: "#EE162D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9639 14.0634C10.9639 14.6008 10.546 15.0187 10.0087 15.0187C9.47138 15.0187 9.05347 14.6008 9.05347 14.0634C9.05347 13.5261 9.47138 13.1082 10.0087 13.1082C10.546 13.1082 10.9639 13.5261 10.9639 14.0634Z",
    fill: "#EE162D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.f8615b21a37a2f01adbad14f6b67c199.svg";
export { ForwardRef as ReactComponent };